export default __webpack_public_path__ + "711668c6277798311e1b7f3cd60982e8.png";